import React from "react"
import { Form } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"

import { selectOperator } from "@/dashboard/Slice"
import { getDashboard } from "@/dashboard/selectors"

const FilterOperator = () => {
  const dispatch = useDispatch()
  const { availableOperators, selectedOperator } = useSelector(getDashboard)

  const onChange = (event) => dispatch(selectOperator({ operator: event.target.value }))

  return (
    <div className="d-inline-flex">
      <Form.Control as="select" onChange={onChange} value={selectedOperator}>
        {availableOperators.map((operator) => (
          <option key={operator}>{operator}</option>
        ))}
      </Form.Control>
    </div>
  )
}

export default FilterOperator
